import { Box, Divider, Typography } from '@mui/material'
import { useContext } from 'react'

import { CenteredLoading } from '../../components'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { DviListContext } from '../../providers/DviListProvider/DviListProvider'
import { useListInspectionsQuery } from '../../redux/api/inspectionApi'
import InspectionCard from '../DviInspections/InspectionCard'

export const DviUnassignedInspection = () => {
  const { shopId, accessToken } = useAccessTokenAndShopId()
  const { repairOrderLookup } = useContext(DviListContext)
  const {
    data: unassignedInspections,
    isLoading: loadingUnassignedInspections
  } = useListInspectionsQuery(
    {
      authorization: accessToken,
      template: false,
      numResults: 150,
      endDateExclusive: '9999-12-31T23:59:59.000Z',
      shop: shopId,
      technicians: undefined,
      isAssigned: false,
      isStarted: false,
      isFinished: false
    },
    { pollingInterval: 60000 }
  )
  return (
    <>
      <Box
        minWidth={300}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'rgba(0, 0, 0, 0.24)',
          border: '1px dotted black',
          borderRadius: 1
        }}>
        <Typography variant="h3">No Inspections Assigned</Typography>
      </Box>
      <Divider orientation="vertical" />
      {loadingUnassignedInspections || !unassignedInspections ? (
        <CenteredLoading />
      ) : unassignedInspections.length === 0 ? (
        <Typography variant="h3">No inspections found</Typography>
      ) : (
        <>
          {unassignedInspections
            ?.filter(
              (inspection) => !!repairOrderLookup[inspection.info!.repairOrder!]
            )
            .map((inspection) => (
              <Box key={inspection.id!} minWidth={300}>
                <InspectionCard
                  {...{ inspection }}
                  repairOrder={repairOrderLookup[inspection.info!.repairOrder!]}
                  key={inspection.id}
                />
              </Box>
            ))}
        </>
      )}
    </>
  )
}
